/* eslint-disable no-console */
import * as React from "react"; 
import { useState, useEffect } from "react";
import Modal from "../core/Modal";
import Button from "../core/Button";
import { jfetch, toast } from "../../utils";
import { ZoomMtg } from '@zoomus/websdk';

ZoomMtg.setZoomJSLib('https://dmogdx0jrul3u.cloudfront.net/1.9.1/lib', '/av'); 
ZoomMtg.preLoadWasm();
ZoomMtg.prepareJssdk();


function Zoom(props){

  // setup your signautre endpoint here: https://github.com/zoom/websdk-sample-signature-node.js
  var apiKey = props.settings.zoom_apikey
  var meetingNumber = props.settings.meeting_number
  var leaveUrl = props.settings.zoom_redirect
  var userName = props.userContext.user.data.attributes.name
  var userEmail = props.userContext.user.data.attributes.email
  var passWord = props.settings.meeting_password

  useEffect(() => {
   init()
  }, [])

  async function init(){
    let s = await getSignature()
    initZoom(s)
  }

  async function getSignature(){
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    let raw = JSON.stringify({"meetingNumber":meetingNumber,"role":0});
    let requestOptions:any = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    const resp = await fetch("https://shrouded-forest-55583.herokuapp.com/", requestOptions)
    const json = await resp.json()
    return json.signature
  }

  function initZoom(sig){
    ZoomMtg.init({
      leaveUrl: leaveUrl,
      isSupportAV: true,
      success: (success) => {
        ZoomMtg.join({
          signature: sig,
          meetingNumber: meetingNumber,
          userName: userName,
          apiKey: apiKey,
          userEmail: userEmail,
          passWord:passWord,
          success: (success) => {
          },
          error: (error) => {
            // console.log('join failed!')
            // console.log(error)
          }
        })
    
      },
      error: (error) => {
        // console.log('init failed!')
        // console.log(error)
      }
    })        
  }

  return(
    <div className="container">
      <div className="row">
        <h3>ZOOM WEBINAR</h3>
      </div>
    </div>
  )
}

export default Zoom


// WEBPACK FOOTER //
// ./app/javascript/components/pages/Zoom.tsx